module.exports = __webpack_public_path__ + "img/荣誉证书05_杨浦区博士后创新实践基地.6228d17a.png";